// Apple Sign In configuration for react-apple-login
export const appleAuthConfig = {
  clientId: process.env.REACT_APP_APPLE_CLIENT_ID || '',
  redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URI || '',
  scope: 'name email',
  responseType: 'code',
  responseMode: 'form_post',
  usePopup: false,
};

// Helper function to initiate Apple Sign In
export const initiateAppleSignIn = () => {
  const { clientId, redirectURI, scope, responseType } = appleAuthConfig;

  const state = JSON.stringify({
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    deviceType: 'web',
    redirectUrl: `${window.location.origin}/callback/apple-auth`,
  });

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectURI,
    response_type: responseType,
    scope: scope,
    state: state,
    response_mode: 'form_post',
  });

  const authUrl = `https://appleid.apple.com/auth/authorize?${params.toString()}`;
  window.location.href = authUrl;
};
